import TYPES from './types';
import { Container } from 'inversify-props';

// Infrastructure
import SearchEmailDummyRepository
  from './infrastructure/repository/search-email-repository/search-email-dummy-repository';
import SearchEmailHttpRepository
  from './infrastructure/repository/search-email-repository/search-email-http-repository';
import VueStateManager from './infrastructure/state/vue-state-manager';

// Application
import OnBoardingSearchEmailsQuery from './application/queries/search-my-investment-emails-query';

// Domain
import StateManager from './domain/state/state-manager';
import SearchEmailRepository from './domain/repository/search-email-repository';

export default function setupEmails(container: Container) {
  const withDummies = process.env.VUE_APP_REPOSITORY_MODE === 'dummy';
  container
    .bind<StateManager>(TYPES.MY_INVESTMENT_EMAIL_STATE_MANAGER)
    .to(VueStateManager)
    .inSingletonScope();

  container
    .bind<SearchEmailRepository>(TYPES.SEARCH_MY_INVESTMENT_EMAIL_REPOSITORY)
    .to(
      withDummies
        ? SearchEmailDummyRepository
        : SearchEmailHttpRepository,
    )
    .inSingletonScope();

  container
    .bind<OnBoardingSearchEmailsQuery>(TYPES.SEARCH_MY_INVESTMENT_EMAILS_QUERY)
    .to(OnBoardingSearchEmailsQuery)
    .inSingletonScope();
}
